import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * "5–8 of 11", with previous / next - the footer of a short paged list (the
 * support queue, the dashboard's assigned seats). Hidden when everything fits
 * on one page, so a small list carries no controls it cannot use.
 *
 * `page` is zero-based; the caller owns it.
 */
export function Pager({
  page,
  pageSize,
  total,
  onPage,
  className,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
  className?: string;
}) {
  const pages = Math.ceil(total / pageSize);
  if (pages <= 1) return null;
  const first = page * pageSize + 1;
  const last = Math.min(total, first + pageSize - 1);
  const arrow =
    'flex size-8 items-center justify-center rounded-lg border border-input hover:border-primary disabled:pointer-events-none disabled:opacity-40';

  return (
    <div className={`flex items-center justify-between gap-2 ${className ?? ''}`}>
      <span className="text-[11.5px] text-muted-foreground">
        {first}–{last} of {total}
      </span>
      <div className="flex items-center gap-1.5">
        <button
          type="button"
          aria-label="Previous page"
          disabled={page === 0}
          onClick={() => {
            onPage(page - 1);
          }}
          className={arrow}
        >
          <ChevronLeft size={15} />
        </button>
        <span className="min-w-12 text-center text-[11.5px] text-muted-foreground">
          {page + 1} / {pages}
        </span>
        <button
          type="button"
          aria-label="Next page"
          disabled={page >= pages - 1}
          onClick={() => {
            onPage(page + 1);
          }}
          className={arrow}
        >
          <ChevronRight size={15} />
        </button>
      </div>
    </div>
  );
}
